var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.7,
    height: 29.815,
    viewBox: "0 0 14.7 29.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(14.699) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M17.692,2.318V9.928a1.94,1.94,0,0,1-1.946,2.086L0,12.267V0L15.741.233A1.94,1.94,0,0,1,17.692,2.318Z",
    transform: "translate(12.123 1.216)",
    fill: "#d6dfe5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(29.652 2.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M0,0A2.391,2.391,0,0,1,.163.893V8.5A2.392,2.392,0,0,1,0,9.395Z",
    fill: "#d44848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M0,0A1.731,1.731,0,0,1,.163.505V7.536A1.668,1.668,0,0,1,0,8.028Z",
    transform: "translate(0 0.694)",
    fill: "#646c72"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M0,6.135c0,6.36,4.218,6.134,4.988,6.134H12.1c.588,0,.814-.538.814-1.2V1.2c0-.664-.226-1.2-.814-1.2H4.988C4.218,0,0-.225,0,6.135Z",
    transform: "translate(0 1.215)",
    fill: "#d6dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M2.976,0h.618a.125.125,0,0,1,.091.2l0,.007a.324.324,0,0,0-.017.029l0,0A5.723,5.723,0,0,0,3.24,1.249a14.988,14.988,0,0,0-.572,4.368A14.993,14.993,0,0,0,3.24,9.984a5.836,5.836,0,0,0,.42,1.01l0,0c.005.01.01.019.017.029l0,0a.125.125,0,0,1-.09.2H2.976a2.879,2.879,0,0,1-1.7-.963C.381,9.39,0,7.779,0,5.613S.387,1.842,1.276.964A2.974,2.974,0,0,1,2.976,0Z",
    transform: "translate(0.441 1.736)",
    fill: "#e9f0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M-.539-1.057H10.742L10.791.886A5.641,5.641,0,0,1-.491.886Z",
    transform: "translate(6.325 12.438) rotate(-90)",
    fill: "#405d72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(3.72 1.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M3.273,0a.484.484,0,0,1-.486.493A5.035,5.035,0,0,1,1.014.338L0,.055V9.832l1.019-.282c.227-.063.133-.113,1.642-.149a.61.61,0,0,1,.613.621h.586V0Z",
    transform: "translate(4.267 0.699)",
    fill: "#d6dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M1.067.231,1.049.26l0,0A5.584,5.584,0,0,0,.6,1.277,14.281,14.281,0,0,0,0,5.645a14.272,14.272,0,0,0,.6,4.367,5.656,5.656,0,0,0,.443,1.01l0,0,.017.029a.5.5,0,0,0,.239.193.524.524,0,0,0,.33.016l.057-.016,2.465-.685h0l.111-.031V.754L4.159.723,1.644.02A.52.52,0,0,0,1.067.231Z",
    fill: "#d6dfe5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M7.039,8.521a.536.536,0,0,1-.512.545,15.484,15.484,0,0,0-3.344.741A20.023,20.023,0,0,1,1,10.238a.04.04,0,0,1-.025,0l-.01-.017,0,0a5.187,5.187,0,0,1-.39-.9A13.733,13.733,0,0,1,0,5.124,13.74,13.74,0,0,1,.575.928a5.034,5.034,0,0,1,.4-.916L.98,0a.05.05,0,0,1,.032,0c.381.107,1.141.161,2.17.433a13.754,13.754,0,0,0,3.344.744.535.535,0,0,1,.512.544Z",
    transform: "translate(4.192 2.23)",
    fill: "#e9f0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M18.517,1.366v5.29a1.308,1.308,0,0,1-1.383,1.363L0,7.965V.079L17.134,0A1.308,1.308,0,0,1,18.517,1.366Z",
    transform: "translate(10.307 3.33)",
    fill: "#e9f0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M3.521.6a.482.482,0,0,1,.328.536,30.371,30.371,0,0,0-.3,4.129,30.565,30.565,0,0,0,.3,4.126.482.482,0,0,1-.329.536l-2,.579a.509.509,0,0,1-.587-.254l0,0a5.339,5.339,0,0,1-.394-.936A13.744,13.744,0,0,1,0,5.267,13.743,13.743,0,0,1,.536,1.219,5.3,5.3,0,0,1,.932.28l0,0A.513.513,0,0,1,1.528.02Z",
    transform: "translate(3.785 2.086)",
    fill: "#405d72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M3.85,1.138a30.375,30.375,0,0,0-.3,3.919A3.719,3.719,0,0,1,.837,6.241,3.634,3.634,0,0,1,.022,6.15Q0,5.716,0,5.267A13.739,13.739,0,0,1,.537,1.219a5.321,5.321,0,0,1,.4-.938l0,0A.514.514,0,0,1,1.528.02L3.521.6A.482.482,0,0,1,3.85,1.138Z",
    transform: "translate(3.785 2.086)",
    fill: "#949bb8",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(0.946 2.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1.5,0V.87A1.041,1.041,0,0,1,.488,1.926h-.2A.96.96,0,0,1,0,1.881,4.007,4.007,0,0,1,.84.52,3.052,3.052,0,0,1,1.5,0Z",
    fill: "#405d72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(0 8.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M.292,0h.2A1.04,1.04,0,0,1,1.5,1.056v.87a3.06,3.06,0,0,1-.665-.52A4,4,0,0,1,0,.044.972.972,0,0,1,.292,0Z",
    fill: "#405d72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(0.442 0.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M.156.853C.243.853.313.662.313.427S.243,0,.156,0,0,.191,0,.427.07.853.156.853Z",
    fill: "#f4e6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M.171.326A.752.752,0,0,0,.118.021a.035.035,0,0,0-.065,0A.749.749,0,0,0,0,.326.75.75,0,0,0,.053.631a.035.035,0,0,0,.065,0A.752.752,0,0,0,.171.326Z",
    transform: "translate(0.071 0.101)",
    fill: "#f4eddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M.142.776C.221.776.285.6.285.388S.221,0,.142,0,0,.174,0,.388.064.776.142.776Z",
    transform: "translate(0.353 0.435)",
    fill: "#f4e6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M.112.4C.173.4.223.309.223.2S.173,0,.112,0,0,.089,0,.2.05.4.112.4Z",
    transform: "translate(0.692 1.103)",
    fill: "#f4bb92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M.171.326a.747.747,0,0,0-.053-.3.035.035,0,0,0-.065,0A.75.75,0,0,0,0,.326.752.752,0,0,0,.053.631a.035.035,0,0,0,.065,0A.75.75,0,0,0,.171.326Z",
    transform: "translate(0.409 0.497)",
    fill: "#f4eddc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(0.442 0.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M.156,0C.243,0,.313.191.313.427S.243.854.156.854,0,.662,0,.427.07,0,.156,0Z",
    transform: "translate(0 0.648)",
    fill: "#f4e6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M.171.326A.752.752,0,0,1,.118.631a.035.035,0,0,1-.065,0A.75.75,0,0,1,0,.326.75.75,0,0,1,.053.021a.035.035,0,0,1,.065,0A.753.753,0,0,1,.171.326Z",
    transform: "translate(0.071 0.748)",
    fill: "#f4eddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M.142,0C.221,0,.285.174.285.388S.221.776.142.776,0,.6,0,.388.064,0,.142,0Z",
    transform: "translate(0.353 0.29)",
    fill: "#f4e6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M.112,0C.173,0,.223.089.223.2S.173.4.112.4,0,.309,0,.2.05,0,.112,0Z",
    transform: "translate(0.692)",
    fill: "#f4bb92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M.171.326A.748.748,0,0,1,.118.631a.035.035,0,0,1-.065,0A.751.751,0,0,1,0,.326a.751.751,0,0,1,.053-.3.035.035,0,0,1,.065,0A.748.748,0,0,1,.171.326Z",
    transform: "translate(0.409 0.352)",
    fill: "#f4eddc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(7.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M.588.077V1.1a.3.3,0,0,1-.294.305H.228A.233.233,0,0,1,0,1.173V.533A.525.525,0,0,1,.514,0h0A.076.076,0,0,1,.588.077Z",
    fill: "#d6dfe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M.588,1.332V.305A.3.3,0,0,0,.294,0H.228A.233.233,0,0,0,0,.236v.64a.525.525,0,0,0,.514.533h0A.076.076,0,0,0,.588,1.332Z",
    transform: "translate(0 13.29)",
    fill: "#d6dfe5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M.218.092A.112.112,0,0,1,.441.113V4.8a.112.112,0,0,1-.223.025A11.633,11.633,0,0,1,0,2.458,11.62,11.62,0,0,1,.218.092Z",
    transform: "translate(0 4.891)",
    fill: "#4e5251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M6.882,1.24-.306,1.22A.587.587,0,0,1-.891.635h0A.587.587,0,0,1-.306.049l7.188.02a.587.587,0,0,1,.585.585h0A.587.587,0,0,1,6.882,1.24Z",
    transform: "translate(12.123 1.709)",
    fill: "#405d72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M6.882,1.24l-6.3-.069A.587.587,0,0,1,0,.585H0A.587.587,0,0,1,.585,0l6.3.069a.587.587,0,0,1,.585.585h0A.587.587,0,0,1,6.882,1.24Z",
    transform: "translate(20.064 1.788)",
    fill: "#405d72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M6.882,0l-7.4.025A.587.587,0,0,0-1.108.61h0A.587.587,0,0,0-.522,1.2l7.4-.025A.587.587,0,0,0,7.468.586h0A.587.587,0,0,0,6.882,0Z",
    transform: "translate(12.123 11.803)",
    fill: "#405d72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M6.882,0,.585.069A.587.587,0,0,0,0,.655H0a.587.587,0,0,0,.585.585l6.3-.069A.587.587,0,0,0,7.468.585h0A.587.587,0,0,0,6.882,0Z",
    transform: "translate(20.064 11.725)",
    fill: "#405d72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarMarker);
export default __webpack_public_path__ + "static/media/car_marker.18325ab4e5a8c664b44cb90bce5c672c.svg";
export { ForwardRef as ReactComponent };